import split from 'lib/storeLocales/split';
import { GetStaticPaths, GetStaticPathsContext, GetStaticPathsResult } from 'next';

interface GetStoreLocalesStaticPathsContext extends GetStaticPathsContext {
  locales: string[];
  storeLocales: string[];
  stores: string[];
}

interface GetStoreLocalesStaticPaths extends GetStaticPaths {
  (context: GetStoreLocalesStaticPathsContext): Promise<GetStaticPathsResult>;
}

const distinct = (array: string[]): string[] => Array.from(new Set(array));

const withStoreLocales =
  (fn: GetStoreLocalesStaticPaths) =>
  (context: GetStaticPathsContext): Promise<GetStaticPathsResult> => {
    const { locales: storeLocales } = context;

    const splitStoreLocales = storeLocales.map(split);

    const locales = distinct(splitStoreLocales.map(([, l]) => l));
    const stores = distinct(splitStoreLocales.map(([s]) => s));

    return fn({ ...context, stores, locales, storeLocales });
  };

export default withStoreLocales;
